import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor editorial feed
 */
export default class HomeNewsValueObject extends ValueObject {
  /**
   * @param {Array<{ sectionId: String, button: String, items: Array<ArticleEntity> }>} items
   */
  constructor({items}) {
    super({items})
    this._items = items
  }

  toJSON() {
    return {
      items: this._items.map(section => ({
        ...section,
        items: section.items.map(item => item.toJSON())
      }))
    }
  }
}
